export default "__VITE_ASSET__cXIHHeNJ__"